import { render, staticRenderFns } from "./totalView.vue?vue&type=template&id=1242ac0a&scoped=true"
import script from "./totalView.vue?vue&type=script&lang=js"
export * from "./totalView.vue?vue&type=script&lang=js"
import style0 from "./totalView.vue?vue&type=style&index=0&id=1242ac0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1242ac0a",
  null
  
)

export default component.exports